
enum ConsentStatusDanish {
    Aktiv = 0,
    Tilbagekaldt = 1
}

enum ConsentTypeContactDanish
{
    SMS = 0,
    "E-mail" = 1,
    Telefon = 2
    //SocialMedia = 3,
    //PostalMail = 4
}

enum ConsentHistoryActionSourceTypeDanish {
    Ukendt = 0,
    Administrator = 1,
    Webservice = 2,
    VirksomhedsListe = 3,
    "Selv via applikation" = 4,
    "Selv via link " = 5,
    "Ekstern Refresh" = 6
}

enum ConsentHistoryActorTypeDanish {
    Administrativ = 0,
    Support = 1,
    Virksomhed = 2,
    Udbyder = 3,
    "Dig selv" = 4
}


enum AccessPermissionTypeDanish
{
    Ingen = 0,
    Opret = 1,
    Tilbagekald = 2,
    Begge = 3
}


enum ConsentListTypeDanish
{
    Upload = 0,
    Revoke = 1
}

enum SubscriptionType {
    Standard = 0,
    Business = 1,
    Enterprise = 2
}

enum UserLoginStatusDanish {
    Ny = 0,
    Succes = 1,
    "Ukendt bruger" = 2,
    "Ugyldigt password" = 3,
    "Ikke flere fors\u00f8g" = 4,
    "Inaktiv" = 5,
    "DB fejl" = 99
}

enum StatisticsPeriodDanish {
    "I dag" = 0,
    "i g\u00e5r" = 1,
    "Uge til dato" = 2,
    "M\u00e5ned til dato" = 3,
    "\u00c5r til dato" = 4,
    "Forrige uge" = 5,
    "Forrige m\u00e5ned" = 6,
    "Forrige \u00c5r" = 7
}


enum AuthenticationTypeDanish
{
    None = 0,
    Basic = 1,
    Bearer = 2,
    "Refresh Token (POST)" = 3,
    "Refresh Token (GET)" = 4
}

enum StakeholderCommsSetupType
{
    Webservice = 0,
    Email = 1
}

enum ConsentRevokeReasonTypeDanish
{
    None = 0,
    "Anden \u00e5rsag" = 1,
    "Jeg har ikke bedt om dette" = 10,
    "Forkert kontakt" = 11,
    Spam = 12,
}

export { ConsentStatusDanish, ConsentTypeContactDanish, ConsentHistoryActionSourceTypeDanish, ConsentHistoryActorTypeDanish, AccessPermissionTypeDanish,
    ConsentListTypeDanish, SubscriptionType, UserLoginStatusDanish, StatisticsPeriodDanish, AuthenticationTypeDanish, StakeholderCommsSetupType, ConsentRevokeReasonTypeDanish };
